import {
  grays,
  colors,
  themeColors,
  buttonColors,
  contentColors,
  toggleColors,
  headingBlockColors,
  inputColors,
  toggleButtonColors,
  dropdownColors,
} from './colors';
import {
  bodyBackground,
  bodyColor,
  fontSizes,
  fontWeights,
  lineHeights,
  inputDisabledBG,
  headingFontSizes,
  fontStyles,
} from './type';
import { spacer, gridBreakpoints, gridGutterWidths } from './grid';
import { borderWidth, borderColor, borderStyle, borderRadii, boxShadows } from './box';
import { fontFamilies } from './fonts';
import modal from './modal';
import alert from './alert';
import zIndex from './zIndex';
import card from './card';
import dropdown from './dropdown';
import popover from './popover';
import tooltip from './tooltip';
import nav from './nav';
import button from './button';

const theme = {
  key: 'default',
  grays,
  colors,
  themeColors,
  toggleColors,
  toggleButtonColors,
  buttonColors,
  inputColors,
  dropdownColors,
  headingBlockColors,
  bodyBackground,
  bodyColor,
  contentColors,
  spacer,
  gridBreakpoints,
  gridGutterWidths,
  borderWidth,
  borderColor,
  borderStyle,
  borderRadii,
  boxShadows,
  transitions: {
    base: 'all 0.2s ease-in-out',
    fade: 'opacity 0.15s linear',
    collapse: 'height 0.35s ease',
    duration: '250ms',
  },
  table: {
    borderWidth: '1px',
    borderColor: grays[400],
  },
  fontFamilies,
  fontSizes,
  fontWeights,
  lineHeights,
  headingFontSizes,
  inputDisabledBG,
  fontStyles,
  modal,
  alert,
  zIndex,
  card,
  dropdown,
  popover,
  tooltip,
  nav,
  button,
  headingTextTransform: 'uppercase',
  // Assets for themes resolved at runtime (Mosaic Configurator demos), where
  // URLs arrive in the theme payload instead of the themeAssets registry.
  // Riding on the theme object keeps concurrent SSR requests isolated.
  // '' means "no runtime asset — resolve from the registry by theme.key".
  brandAssets: {
    logoUrl: '',
  },
};

export default theme;
